import { HttpClient } from '@angular/common/http';
export class ApiMethodConfiguration {
    path: string;
    method: string;
    headers: ApiMethodHeaders;
}
export class ApiMethodHeaders {

    Accept = 'application/json';
    'Content-Type' = 'application/json; charset=UTF-8';
    'x-ss-origin' = 'CUP';
    authorization?: string;

    constructor(param?: { token?: string }) {
        if (param && param.token) {
            this.authorization = 'Bearer ' + param.token;
        }
    }

}

/**
 * Holds all the configurations needed for all API calls.
 */
export class CTAPIConfiguration {

    public order = this.getOrdersEndpoints();
    public orderAnonymous = this.getOrdersAnonymousEndpoints();
    public settings = this.getSettingsEndpoints();
    public address = this.getAddressEndpoints();
    public insurance = this.getInsuranceEndpoints();
    public customer = this.getCustomerEndpoints();
    public part = this.getPartsEndpoints();
    public reason = this.getReasonEndpoints();
    public account = this.getAccountEndpoints();
    public materialOrder = this.getMaterialOrdersEndpoints();
    public materialOrderAnonymous = this.getMaterialOrdersAnonymousEndpoints();
    public salesOrderOrganization = this.getSalesOrganizationEndpoints();
    public geoproxy = this.getGeoProxyEndpoints();

    constructor(public baseUrl: string, public apiSecret: string, public httpClient?: HttpClient) { }

    private getEndpointsPrefix() {
        return '/api/cp/customerPortal';
    }

    private getOrdersAnonymousEndpoints() {
        return {
            search: {
                path: this.getEndpointsPrefix() + '/ctSalesOrder/searchSalesOrder',
                method: 'POST',
                headers: new ApiMethodHeaders()
            },
            mapInfo: {
                path: this.getEndpointsPrefix() + '/ctSalesOrder/mapInfo',
                method: 'POST',
                headers: new ApiMethodHeaders()
            }
        };
    }

    private getOrdersEndpoints() {
        return {
            create: {
                path: this.getEndpointsPrefix() + '/ctSalesOrder/createSalesOrder',
                method: 'POST',
                headers: new ApiMethodHeaders({
                    token: this.apiSecret
                })
            },
            createManyMatOrders: {
                path: this.getEndpointsPrefix() + '/ctSalesOrder/createSalesOrderManyMatOrders',
                method: 'POST',
                headers: new ApiMethodHeaders({
                    token: this.apiSecret
                })
            },
            list: {
                path: this.getEndpointsPrefix() + '/ctSalesOrder/getSalesOrders',
                method: 'POST',
                headers: new ApiMethodHeaders({
                    token: this.apiSecret
                })
            },
            get: {
                path: this.getEndpointsPrefix() + '/ctSalesOrder/getSalesOrder',
                method: 'POST',
                headers: new ApiMethodHeaders({
                    token: this.apiSecret
                })
            },
            filter: {
                path: this.getEndpointsPrefix() + '/ctSalesOrder/searchSalesOrdersWithPagination',
                method: 'POST',
                headers: new ApiMethodHeaders({
                    token: this.apiSecret
                })
            },
            search: {
                path: this.getEndpointsPrefix() + '/ctSalesOrder/searchSalesOrder',
                method: 'POST',
                headers: new ApiMethodHeaders({
                    token: this.apiSecret
                })
            },
            acceptQuote: {
                path: this.getEndpointsPrefix() + '/ctSalesOrder/acceptQuote',
                method: 'POST',
                headers: new ApiMethodHeaders({
                    token: this.apiSecret
                })
            },
            rejectQuote: {
                path: this.getEndpointsPrefix() + '/ctSalesOrder/rejectQuote',
                method: 'POST',
                headers: new ApiMethodHeaders({
                    token: this.apiSecret
                })
            },
            mapInfo: {
                path: this.getEndpointsPrefix() + '/ctSalesOrder/mapInfo',
                method: 'POST',
                headers: new ApiMethodHeaders({
                    token: this.apiSecret
                })
            }
        };
    }

    private getAccountEndpoints() {
        return {
            notifyNewAccount: {
                path: this.getEndpointsPrefix() + '/mdDivs/newAccountRequestEvent',
                method: 'POST',
                headers: new ApiMethodHeaders({
                    token: this.apiSecret
                })
            }
        };
    }

    private getSettingsEndpoints() {
        return {
            get: {
                path: this.getEndpointsPrefix() + '/mdSettings/getSettings',
                method: 'POST',
                headers: new ApiMethodHeaders()
            }
        };
    }

    private getAddressEndpoints() {
        return {
            get: {
                path: this.getEndpointsPrefix() + '/mdLocas/getAddresses',
                method: 'POST',
                headers: new ApiMethodHeaders({
                    token: this.apiSecret
                })
            },
            create: {
                path: this.getEndpointsPrefix() + '/mdLocas/saveAddress',
                method: 'POST',
                headers: new ApiMethodHeaders({
                    token: this.apiSecret
                })
            },
            validate: {
                path: this.getEndpointsPrefix() + '/mdLocas/validateAddress',
                method: 'POST',
                headers: new ApiMethodHeaders({
                    token: this.apiSecret
                })
            },
            getByCustomer: {
                path: this.getEndpointsPrefix() + '/mdLocas/getAddressesByCustomer',
                method: 'POST',
                headers: new ApiMethodHeaders()
            },
        };
    }

    private getInsuranceEndpoints() {
        return {
            get: {
                path: this.getEndpointsPrefix() + '/mdChrgs/getInsurances',
                method: 'POST',
                headers: new ApiMethodHeaders({
                    token: this.apiSecret
                })
            },
            getCosts: {
                path: this.getEndpointsPrefix() + '/mdCostObjects/getCostObjects',
                method: 'POST',
                headers: new ApiMethodHeaders({
                    token: this.apiSecret
                })
            },
            linkFiles: {
                path: this.getEndpointsPrefix() + '/relFiles/insert',
                method: 'POST',
                headers: new ApiMethodHeaders({
                    token: this.apiSecret
                })
            },
            unlinkFiles: {
                path: this.getEndpointsPrefix() + '/relFiles/delete',
                method: 'POST',
                headers: new ApiMethodHeaders({
                    token: this.apiSecret
                })
            }
        };
    }

    private getCustomerEndpoints() {
        return {
            get: {
                path: this.getEndpointsPrefix() + '/mdCusts/getCustomers',
                method: 'POST',
                headers: new ApiMethodHeaders({
                    token: this.apiSecret
                })
            },
            getByCode: {
                path: this.getEndpointsPrefix() + '/mdCusts/findByCustomerCode',
                method: 'POST',
                headers: new ApiMethodHeaders()
            }
        };
    }

    private getPartsEndpoints() {
        return {
            get: {
                path: this.getEndpointsPrefix() + '/mdParts/getParts',
                method: 'POST',
                headers: new ApiMethodHeaders({
                    token: this.apiSecret
                })
            },
            getHandlingGuidelines: {
                path: this.getEndpointsPrefix() + '/mdHandlings/getHandlingGuidelines',
                method: 'POST',
                headers: new ApiMethodHeaders({
                    token: this.apiSecret
                })
            },
            getQuestionnaire: {
                path: this.getEndpointsPrefix() + '/mdQuestionnaire/getQuestionnaires',
                method: 'POST',
                headers: new ApiMethodHeaders({
                    token: this.apiSecret
                })
            }
        };
    }

    private getReasonEndpoints() {
        return {
            get: {
                path: this.getEndpointsPrefix() + '/mdReass/getReasons',
                method: 'POST',
                headers: new ApiMethodHeaders({
                    token: this.apiSecret
                })
            }
        };
    }

    private getMaterialOrdersAnonymousEndpoints() {
        return {
            search: {
                path: this.getEndpointsPrefix() + '/ctMatOrder/searchMatOrder',
                method: 'POST',
                headers: new ApiMethodHeaders()
            },
            mapInfo: {
                path: this.getEndpointsPrefix() + '/ctMatOrder/mapInfo',
                method: 'POST',
                headers: new ApiMethodHeaders()
            },
        };
    }

    private getMaterialOrdersEndpoints() {
        return {
            filter: {
                path: this.getEndpointsPrefix() + '/ctMatOrder/searchMatOrdersWithPagination',
                method: 'POST',
                headers: new ApiMethodHeaders({
                    token: this.apiSecret
                })
            },
            search: {
                path: this.getEndpointsPrefix() + '/ctMatOrder/searchMatOrder',
                method: 'POST',
                headers: new ApiMethodHeaders({
                    token: this.apiSecret
                })
            },
            create: {
                path: this.getEndpointsPrefix() + '/ctMatOrder/createOrReplaceMatOrder',
                method: 'POST',
                headers: new ApiMethodHeaders({
                    token: this.apiSecret
                })
            },
            mapInfo: {
                path: this.getEndpointsPrefix() + '/ctMatOrder/mapInfo',
                method: 'POST',
                headers: new ApiMethodHeaders({
                    token: this.apiSecret
                })
            },
            getRelatedFiles: {
                path: this.getEndpointsPrefix() + '/relFiles/selectAll',
                method: 'POST',
                headers: new ApiMethodHeaders({
                    token: this.apiSecret
                })
            }
        };
    }

    private getSalesOrganizationEndpoints() {
        return {
            list: {
                path: this.getEndpointsPrefix() + '/mdOrganizations/getOrganizations',
                method: 'POST',
                headers: new ApiMethodHeaders({
                    token: this.apiSecret
                })
            }
        };
    }

    private getGeoProxyEndpoints() {
        return {
            getSuggestions: {
                path: this.getEndpointsPrefix() + '/geoproxy/getSuggestions',
                method: 'POST',
                headers: new ApiMethodHeaders({
                    token: this.apiSecret
                })
            }
        };
    }

}
